import { render, staticRenderFns } from "./ReviewBlock.vue?vue&type=template&id=6015e690"
import script from "./ReviewBlock.vue?vue&type=script&lang=ts"
export * from "./ReviewBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports